export enum TranslationKeys {
    PUPIL = 'pupil',
    PUPILS = 'pupils',
}

export type TranslationKey = `${TranslationKeys}`;
